export class BulkDeliveryInput {
  public LocationId!: number;
  public DeliveryDate!: string;
  public UserId!: number;
  public GRList: any[] = [];
}